import React from 'react';
import { useApp } from '../../core/AppContext';

export default function AiIntakeView() {
  useApp();
  return (
    <div style={{ backgroundColor: '#fff', borderRadius: '8px', padding: '40px', textAlign: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', marginTop: '10px' }}>
      <div style={{ fontSize: '40px', marginBottom: '10px' }}>📥</div>
      <h2 style={{ color: '#0f2027', margin: '0 0 10px 0' }}>EEA AI Intake & Governance</h2>
      <p style={{ color: '#718096', fontSize: '14px', maxWidth: '500px', margin: '0 auto 20px auto' }}>
        Enterprise intake portal for submitting new LLM use-cases and architecture reviews.
      </p>
      <span style={{ backgroundColor: '#feebc8', color: '#c05621', padding: '6px 16px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' }}>
        🚧 UPCOMING FEATURE — Phase 2
      </span>
    </div>
  );
}
